import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle<{
  rtl: boolean;
}>`
    * {
        box-sizing: border-box;
        margin: 0;
    }

    body {
        background: ${({ theme }) =>
          'colors' in theme &&
          typeof theme.colors === 'object' &&
          theme.colors &&
          'background' in theme.colors &&
          typeof theme.colors.background === 'string'
            ? theme.colors.background
            : ''};
        overflow: hidden;
        overscroll-behavior: none;
        font-family: ${({ rtl }) =>
          rtl ? 'NotoNastaliq, serif' : 'Lato, Arial, Helvetica, sans-serif;'};
    }


    button {
        border: 0,  
        margin: 0
    }

    input:focus {
        outline: none;
    }
    div:focus {
        outline: none;
    }
`;
